/**
 * The app's editor hints (OnboardingFlowController, TutorialActions), each shown once in this browser as the app keeps
 * a flag per hint (`Settings.DrawWallsHintShowed` and the like): `hp.hint.<id>` once it has been on screen. The ones
 * that start a room — drawing the walls, moving one, going over to 3D — are for a project made in this tab, as the
 * app's are for a new project (EditorHelper.IsNewProject).
 */
export type HintId = 'drawWalls' | 'moveWall' | 'room2d3d' | 'makePhoto' | 'cloneNightstand';

const key = (id: HintId) => `hp.hint.${id}`;
/** Whether a hint has been shown; a storage that cannot be read counts as shown, so nothing nags on every visit. */
export function hintShown(id: HintId): boolean {
  try { return localStorage.getItem(key(id)) !== null; } catch { return true; }
}
export function markHintShown(id: HintId): void {
  try { localStorage.setItem(key(id), String(Date.now())); } catch { /* It may show again next time. */ }
}

const NEW_PROJECT = 'hp.hint.newProject';
/** A project made in this tab: from «Новый проект», drawn by hand or recognized from a plan. */
export function markNewProject(id: string): void {
  try { sessionStorage.setItem(NEW_PROJECT, id); } catch { /* Then its hints are not offered. */ }
}
export function isNewProject(id: string | null): boolean {
  if (!id) return false;
  try { return sessionStorage.getItem(NEW_PROJECT) === id; } catch { return false; }
}

/** The pieces a level holds before the app suggests a photo of it (FurnitureAddedRichedToShowRenderHint), and how many must have come this visit. */
export const PHOTO_HINT_ITEMS = 4, PHOTO_HINT_ADDED = 3;
